.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  background: #fffbf1;
  overflow-y: scroll;
}

.container {
  max-width: 450px;
  width: 100%;
  padding: 30px 20px 38px 20px;
  margin: 0 auto;
}

.content {
  background: #f3eddf;
  padding: 0 20px;
  padding-bottom: 20px;
  border-radius: 0 0 32px 32px;
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      background-color: #181716;
      border-color: var(--ed-border, #2a2928);
    }

    .content {
      background-color: #2a2928;
    }
  }
}
